export const scrollToTop = () => {
  window.scroll(0, 0);
  document
    .getElementById('root')
    ?.children?.[0]?.scrollTo({ top: 0, behavior: 'smooth' });
};
